import React from "react";

import "./styles.css";

/**
 * @function ImportFileAdditionalValuesMobileTable
 * @return {React.Component}
 * @exported true
 * @description The mobile Import File Additional Values table for the ImportFileAdditionalValuesWidget.
 */
export default function ImportFileAdditionalValuesMobileTable(prop) {
    return (
        <div className="import-file-additional-values-mobile-table">
            <ImportFileAdditionalValuesMobileTableItem />
        </div>
    )
}

/**
 * @function ImportFileAdditionalValuesMobileTableItem
 * @return {React.Component}
 * @exported false
 * @description The mobile Import File Additional Values table row for the ImportFileAdditionalValuesMobileTable.
 */
function ImportFileAdditionalValuesMobileTableItem(prop) {
    return (
        <div className="import-file-additional-values-mobile-table-item">
            <div className="flex-container align-center detail-container type">
                <div className="flex-width">
                    <span className="detail-label">Type:</span>
                </div>
                <div className="set-width">
                    <span className="detail-text"></span>
                </div>
            </div>
            <div className="flex-container align-center detail-container value">
                <div className="flex-width">
                    <span className="detail-label">Value:</span>
                </div>
                <div className="set-width">
                    <span className="detail-text"></span>
                </div>
            </div>
        </div>
    )
}